module.exports = __webpack_public_path__ + "img/Badeurlaub.efd352ab.svg";